import axios from 'axios';

import {
  IMappingsAnalyticsPayload,
  ISubmissionAnalyticsPayload,
  ISubmissionAnalyticsSearchFilterQuery,
} from '../../AnalyticsService';

const url = 'wsreporting/api/composable-analytics';
export const SUBMISSIONS_COMPOSABLE_URL = 'api/composable-analytics';

const candidatesearchUrl = 'candidatesearch/api/submission-analytics';

export const submissionsMetricCharts = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/submissions-metric-charts`, searchFilter);

export const getAllInteractionsCounts = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/all-interactions`, searchFilter);

export const submissionsBarCharts = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/submissions-bar-charts`, searchFilter);

export const submissionsTablesUsers = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/submissions-tables-users`, searchFilter);

export const submissionsTablesClients = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/submissions-tables-clients`, searchFilter);

export const submissionsTablesAccountManagers = (
  searchFilter: ISubmissionAnalyticsSearchFilterQuery
) => axios.post(`${url}/submissions-tables-account-managers`, searchFilter);

export const submissionsTablesSources = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/submissions-tables-sources`, searchFilter);

export const submissionsTablesJobTypes = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/submissions-tables-job-types`, searchFilter);

export const submissionsStackedBarCharts = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/submissions-stacked-bar-charts`, searchFilter);

export const clientWiseSubmissions = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/submissions-by-clients`, searchFilter);

export const submissionsByAm = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/submissions-by-am-job-type`, searchFilter);

export const submissionsByRecruitersAndTeams = (
  searchFilter: ISubmissionAnalyticsSearchFilterQuery
) => axios.post(`${url}/submissions-by-users-with-teams`, searchFilter);

export const submissionsTablesJobTitleComplex = (
  searchFilter: ISubmissionAnalyticsSearchFilterQuery
) => axios.post(`${url}/submissions-tables-job-title-complex`, searchFilter);

export const submissionsTablesCandidateComplex = (
  searchFilter: ISubmissionAnalyticsSearchFilterQuery
) => axios.post(`${url}/submissions-tables-candidate-complex`, searchFilter);

export const getInteractionsByModifiedBy = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/interactions-by-modified-by`, searchFilter);

export const getJobsWorkedOnByRecruiter = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/jobs-worked-on-by-recruiter`, searchFilter);

export const getRecruiterInteractionsTeamWise = (
  searchFilter: ISubmissionAnalyticsSearchFilterQuery
) => axios.post(`${url}/recruiter-interactions-team-wise`, searchFilter);

export const cvViewTablesDownloadSource = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/cv-view-tables-download-source`, searchFilter);

export const submissionsTableRecruiterAction = (
  searchFilter: ISubmissionAnalyticsSearchFilterQuery
) => axios.post(`${url}/submissions-tables-recruiter-actions`, searchFilter);

export const submissionsTableSentRTR = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/submissions-tables-sent-rtr`, searchFilter);

export const submissionsTableCandidateResponse = (
  searchFilter: ISubmissionAnalyticsSearchFilterQuery
) => axios.post(`${url}/submissions-tables-candidate-response`, searchFilter);

export const submissionsTablesDownloadSources = (
  searchFilter: ISubmissionAnalyticsSearchFilterQuery
) => axios.post(`${url}/submissions-tables-download-sources`, searchFilter);

export const submissionsClientAndClientSPOC = (
  searchFilter: ISubmissionAnalyticsSearchFilterQuery
) => axios.post(`${url}/submissions-tables-client-and-client-spoc`, searchFilter);

export const submissionsRecruiterDownloadSourceCandidateStatusWiseTable = (
  searchFilter: ISubmissionAnalyticsSearchFilterQuery
) => axios.post(`${url}/submissions-recruiter-download-source-candidate-status`, searchFilter);

export const submissionsRecruiterSourceCandidateStatusWiseTable = (
  searchFilter: ISubmissionAnalyticsSearchFilterQuery
) => axios.post(`${url}/submissions-recruiter-source-candidate-status`, searchFilter);

export const submissionsSplitByStages = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/submissions-split-by-stage`, searchFilter);

export const submissionsByClientPostgres = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/postgres/submissions-clients`, searchFilter);

export const submissionsByAmPostgres = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/postgres/submissions-acc-manager`, searchFilter);

export const submissionsByUserPostgres = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/postgres/submissions-users`, searchFilter);

export const submissionsByJobTypePostgres = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${candidatesearchUrl}/submissions-by-jobType`, searchFilter);

export const submissionsBySourcePostgres = (searchFilter: ISubmissionAnalyticsSearchFilterQuery) =>
  axios.post(`${url}/postgres/submissions-source`, searchFilter);

const analytics_reporting_url =
  '/analyticsreportingapp/api/candidate-submission/composable-analytics';

export const getSubmissionInPostgre = (
  searchQuery: ISubmissionAnalyticsPayload,
  abortController: AbortController
) =>
  axios.post(`${analytics_reporting_url}?type=${searchQuery.type}`, searchQuery, abortController);

export const getMappingsInPostgre = (
  searchQuery: IMappingsAnalyticsPayload,
  abortController: AbortController
) =>
  axios.post(
    `/analyticsreportingapp/api/candidate-mapping/composable-analytics?type=${searchQuery.type}`,
    searchQuery,
    abortController
  );
